import React from "react";
import { twJoin } from "tailwind-merge";

import { type ToggleProps, SupToggle } from "./components/Toggle";

export type SwitcherProps = Omit<ToggleProps, "renderIcon" | "inputType">;

const renderSwitcherIcon = (checked: boolean) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.6 10C7.6 10.8837 6.88366 11.6 6 11.6C5.11634 11.6 4.4 10.8837 4.4 10C4.4 9.11636 5.11634 8.40001 6 8.40001C6.88366 8.40001 7.6 9.11636 7.6 10ZM6.8 10C6.8 10.4418 6.44183 10.8 6 10.8C5.55817 10.8 5.2 10.4418 5.2 10C5.2 9.55818 5.55817 9.20001 6 9.20001C6.44183 9.20001 6.8 9.55818 6.8 10Z"
      fill="currentColor"
      className={twJoin("transition-transform duration-200", checked ? "translate-x-2" : "translate-x-0")}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.8 5.20001C4.14903 5.20001 2 7.34905 2 10C2 12.651 4.14903 14.8 6.8 14.8H13.2C15.851 14.8 18 12.651 18 10C18 7.34905 15.851 5.20001 13.2 5.20001H6.8ZM13.2 6.00001H6.8C4.59086 6.00001 2.8 7.79087 2.8 10C2.8 12.2092 4.59086 14 6.8 14H13.2C15.4091 14 17.2 12.2092 17.2 10C17.2 7.79087 15.4091 6.00001 13.2 6.00001Z"
      fill="currentColor"
    />
  </svg>
);

export function SupSwitcher(props: SwitcherProps) {
  return <SupToggle {...props} inputType="checkbox" renderIcon={renderSwitcherIcon} />;
}
